<script>
  import MasonryProduct from "./MasonryProduct.svelte";

  export let products = null;
</script>

<ul class="masonry-products">
  {#each products as product}
    <MasonryProduct {product} />
  {/each}
</ul>

<style>
  .masonry-products {
    padding: 0px;
    margin: 0px;
    display: flex;
    flex-wrap: wrap;
  }
</style>
